import React from 'react';
import ControlledInput from './controlledInput'
import Editable from './editable'
import api from './apiConnector'

class Operateur extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password:''
        }
    }

    onChangePassword() {
        api.post(
            {action:'set_password',login:this.props.user.login,password:this.state.password},
            (res)=>{
                this.setState({password:''})
            }
        )
    }

    onChangeEmail(email) {
        const me = this
        api.post(
            {action:'set_email',login:this.props.user.login,email:email},
            (res)=>{
                me.props.container.setState({users:res.users})
            }
        )
    }


    onChangeTelephone(telephone) {
        const me = this
        api.post(
            {action:'set_telephone',login:this.props.user.login,telephone:telephone},
            (res)=>{
                me.props.container.setState({users:res.users})
            }
        )
    }

    onDelete() {
        if ( window.confirm( 'Supprimer l\'utilisateur '+this.props.user.login + ' ?' )) {
            const me = this
            api.post(
                {action:'delete_user',login:this.props.user.login},
                (res)=>{
                    me.props.container.setState({users:res.users})
                }
            )
        }
    }

    render() {
        let deleteButton = ( this.props.user.login != 'admin' )?
            <img src='img/delete-bin-line.png' className='button' onClick={this.onDelete.bind(this)}/> : ''

        return <tr>
            <td>{deleteButton}</td>
            <td>{this.props.user.login}</td>
            <td><Editable value={this.props.user.email} onSubmit={this.onChangeEmail.bind(this)}/></td>
            <td><Editable value={this.props.user.telephone} onSubmit={this.onChangeTelephone.bind(this)}/></td>
            <td>
                <ControlledInput type='password' property='password' container={this} onSubmit={this.onChangePassword.bind(this)}/>
                <button disabled={!this.state.password} onClick={this.onChangePassword.bind(this)}>Modifier</button>
            </td>
            <td></td>
        </tr>
    }
}

class Operateurs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            users:[],
            login:'',
            email:'',
            telephone:'',
            password:''
        }
    }

    componentDidMount() {
        api.post(
            {action:'list_users'},
            (res)=>{
                this.setState({users:res.users})
            }
        )
    }

    renderUser(user) {
        return <Operateur container={this} api={api} user={user} key={user.login}/>
    }

    onAdd() {
        api.post({
            action:'register',
            login:this.state.login,
            email:this.state.email,
            telephone:this.state.telephone,
            password:this.state.password
        },
        (res)=>{
            this.setState({users:res.users})
        }
        )
    }

    render() {

        return <table>
            <tbody>
                <tr>
                    <th></th>
                    <th>Login</th>
                    <th>Email</th>
                    <th>Téléphone</th>
                    <th>Mot de passe</th>
                    <th></th>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <ControlledInput type='text' property='login' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </td>
                    <td>
                        <ControlledInput type='text' property='email' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </td>
                    <td>
                        <ControlledInput type='text' property='telephone' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </td>
                    <td>
                        <ControlledInput type='password' property='password' container={this} onSubmit={this.onAdd.bind(this)}/>
                    </td>
                    <td>
                        <button onClick={this.onAdd.bind(this)}>Créer</button>
                    </td>
                </tr>
                {this.state.users.map( this.renderUser.bind(this) )}
            </tbody>
        </table>
    }
}

export default Operateurs;
